/** Temporary function to define if we are within the Valentine's day event of 2025. */
export function isValentinePeriod(): boolean {
    // Uncomment the following line for testing.
    // return true;

    const today = new Date();
    return (
        today.getFullYear() === 2025 &&
        today.getMonth() === 1 &&
        today.getDate() >= 10 &&
        today.getDate() <= 14
    );
}
